// @docs https://[domain]/api/v1/docs
export default {
  SignIn: "/auth/signin",
  Login: "/auth/login",
  Logout: "/auth/logout",
  GetMe: "/auth/me",
  RefreshToken: "/auth/refresh-token",
  Permissions: "/auth/perms",
  UserInfo: "/auth/userinfo",
  GenerateOTP: "/otps/generate",
};
